import AbstractPageBaseController from '../../../../core/abstracts/controllers/page-controller';

export default class ContactsBaseDetailsPageController extends AbstractPageBaseController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.navService = this.injector.get('NavService');
        this.navHelper = this.injector.get('NavHelper');
        this.locale = this.injector.get('locale');
        this.loading = true;

        this.contact = null;
    }

    $onInit() {
        if (!this.stateParams.contact) {
            this._loadContact();
        } else {
            this.contact = this.stateParams.contact;
            this.loading = false;
            this._contactUpdatedActions()
        }
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.stateParams.id;
        }, () => {
            this._loadContact();
        });
    }

    _contactUpdatedActions() {
        this._setSelectedIndex();
        this._updateToolbox();
        this._updateNavHelperTranslationParams();
    }

    _loadContact() {
        this.loading = true;
        return this.api.get(`contacts/${this.stateParams.id}?include=categories`)
            .then(response => {
                this.contact = response.data.data;
                this.stateParams.contact = _.cloneDeep(this.contact);
                this.loading = false;
                this._contactUpdatedActions();

                return response;
            }, err => {
                this.alert.handle(err);
                this.state.go(this.params.back, this.params.backParams);
            });
    }

    _setSelectedIndex() {
        if (this.store) {
            const contact = this.store.state.slug === 'rsvps' ? {contact: {id: this.contact.id}} : {id: this.contact.id};
            this.selectedIndex = _.findIndex(this.store.state.data, contact);
        }
    }

    _updateToolbox() {
    }

    _updateNavHelperTranslationParams() {
        this.navHelper.setTranslationsParamsForEntry('addressbook.details.main', {
            full_name: _.get(this.contact, 'full_name', '')
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/pages/details/base.js